module.exports = __webpack_public_path__ + "static/media/hea_ass_hea_eff.87fe2e0c.png";